<div id="advanced-filter-toolpanel">
    <app-accordion-headers
        [panelOpenState]="true"
        sectionName="Product Filters"
        (panelStateChanged)="onPanelStateChanged($event)"
        [attr.panelFlex]="
            (openPanels.includes('product_filters') && openPanels.length === 1) || openPanels.length === 0 ? 2 : 1
        "
    >
        <!-- Reset Product Filters -->
        <span class="reset-button-wrapper">
            <button
                mat-button
                color="warn"
                (click)="onResetProductFilters($event)"
                [disabled]="treeDataInitializing || loadingProdHier"
            >
                Clear
            </button>
        </span>
        <!-- Loading Placeholder -->
        <div *ngIf="treeDataInitializing || loadingProdHier">
            <app-loader class="loading-container" [loadingMessage]="'loading'"></app-loader>
        </div>
        <!-- Tree Data -->
        <div *ngIf="!treeDataInitializing && !loadingProdHier">
            <p-tree
                #prodHierTreeData
                [value]="treeData"
                [(selection)]="allSelectedProductNodes"
                class="w-full custom-prod-tree custom-vertical-scroll"
                selectionMode="checkbox"
                (onNodeSelect)="onNodeSelectionChange($event, true)"
                (onNodeUnselect)="onNodeSelectionChange($event, false)"
                (onNodeExpand)="toggleNodeExpanded($event)"
                [loading]="loadingNodeChildren"
                [metaKeySelection]="false"
            >
                <!-- Empty message -->
                <ng-template pTemplate="empty" id="product-filter-empty-message">
                    <p>No Products Found.</p>
                </ng-template>
                <!-- Node Display -->
                <ng-template let-node pTemplate="default">
                    <span class="custom-prod-node-wrapper">
                        <p class="node-item">
                            {{ node.label }}
                        </p>
                    </span>
                </ng-template>
            </p-tree>
        </div>
    </app-accordion-headers>
    <!-- Filter Buttons -->
    <span class="filter-footer">
        <!-- Apply Filters -->
        <button
            mat-raised-button
            color="accent"
            (click)="onApplyAllFilters($event)"
            [disabled]="loadingProdHier || treeDataInitializing"
        >
            Apply All
        </button>
        <!-- Cancel Filters -->
        <button
            mat-button
            color="warn"
            (click)="onResetAllFilters($event)"
            [disabled]="loadingProdHier || treeDataInitializing"
        >
            Clear All
        </button>
    </span>
</div>
